
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/blog/all-articles",
      function () {
        return require("private-next-pages/resources/blog/all-articles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/blog/all-articles"])
      });
    }
  